<footer class="footer-section-wrapper">
  <div class="footer-row">
    <div class="footer-column">
      © {{currentYear}} Scandinavian Airlines System Denmark-Norway-Sweden, org.nr
      902001-7720, 195 87 Stockholm
    </div>
    <div class="footer-br-line"></div>
    <div class="footer-column">
      <img src="/onboard/assets/images/SKT-WHITE-RGB-LOGO.png" />
    </div>
  </div>
</footer>